/* RAVEN Signature v3 — panier AJAX, tiroirs, variantes, galerie, barre d'achat fixe */
(function () {
  'use strict';
  window.RAVEN_READY = true;
  var routes = (window.theme && window.theme.routes) || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function isCartPage() { return document.body.classList.contains('template-cart'); }

  /* Apparition au défilement */
  var io = ('IntersectionObserver' in window) && !reduceMotion ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 }) : null;
  function initReveal(scope) {
    $$('[data-animate]:not(.is-visible)', scope).forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-visible'); });
  }

  /* Tiroirs : menu, recherche, panier */
  var lastFocus = null;
  function closeDrawer(d) {
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    $$('[data-open="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!$('.drawer.is-open, .search-drawer.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function closeAll() { $$('.drawer.is-open, .search-drawer.is-open').forEach(closeDrawer); }
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return false;
    closeAll();
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$('[data-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var target = $('input[type="search"]', d) || $('.drawer__panel, .search-drawer__panel', d);
    setTimeout(function () { if (target) target.focus({ preventScroll: true }); }, 80);
    return true;
  }

  /* Panier (Section Rendering API) */
  var Cart = {
    render: function (sections) {
      var html = sections && sections['cart-drawer'];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-cart-inner]', doc);
      var current = $('[data-cart-inner]');
      if (fresh && current) current.parentNode.replaceChild(document.importNode(fresh, true), current);
      var count = fresh ? parseInt(fresh.getAttribute('data-count'), 10) || 0 : 0;
      $$('[data-cart-count]').forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
    },
    add: function (form) {
      var fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);
      return fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok || d.status) throw new Error(d.description || d.message || 'Impossible d\'ajouter ce produit.');
            return d;
          });
        });
    },
    change: function (line, quantity) {
      var drawer = $('#CartDrawer');
      if (drawer) drawer.classList.add('is-updating');
      return fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (isCartPage()) { window.location.reload(); return; }
          Cart.render(d.sections);
        })
        .catch(function () { window.location.reload(); })
        .then(function () { var dr = $('#CartDrawer'); if (dr) dr.classList.remove('is-updating'); });
    }
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      if (opener.getAttribute('data-open') === 'CartDrawer' && isCartPage()) return;
      if (openDrawer(opener.getAttribute('data-open'))) e.preventDefault();
      return;
    }
    var closer = e.target.closest('[data-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer, .search-drawer')); return; }
    var line = e.target.closest('[data-line]');
    if (line) {
      var n = parseInt(line.getAttribute('data-line'), 10);
      var input = $('[data-line-qty]', line);
      var q = input ? parseInt(input.value, 10) || 0 : 0;
      if (e.target.closest('[data-qty-minus]')) Cart.change(n, Math.max(0, q - 1));
      else if (e.target.closest('[data-qty-plus]')) Cart.change(n, q + 1);
      else if (e.target.closest('[data-line-remove]')) Cart.change(n, 0);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* Ajout au panier sans rechargement */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    e.preventDefault();
    var btn = $('[data-add-button]', form);
    var err = $('[data-form-error]', form);
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    if (err) { err.hidden = true; err.textContent = ''; }
    Cart.add(form)
      .then(function (d) { Cart.render(d.sections); openDrawer('CartDrawer'); })
      .catch(function (x) { if (err) { err.textContent = x.message || 'Impossible d\'ajouter ce produit. Réessayez.'; err.hidden = false; } })
      .then(function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); });
  });

  /* Variantes */
  function priceHtml(v) {
    var sale = v.compare > v.price;
    var html = '<div class="price' + (sale ? ' price--sale' : '') + '"><span class="price__current">' + v.priceHtml + '</span>';
    if (sale) html += '<s class="price__compare"><span class="visually-hidden">Prix habituel </span>' + v.compareHtml + '</s><span class="price__badge">-' + Math.floor((v.compare - v.price) * 100 / v.compare) + ' %</span>';
    return html + '</div>';
  }
  function onVariantChange(radio) {
    var root = radio.closest('[data-product-root]');
    if (!root) return;
    if (!root.__variants) {
      var data = $('[data-variants]', root);
      try { root.__variants = JSON.parse(data.textContent); } catch (x) { return; }
    }
    var selected = $$('fieldset', root).map(function (fs) { var c = $('input[type="radio"]:checked', fs); return c ? c.value : null; });
    var v = root.__variants.filter(function (x) { return x.options.every(function (o, i) { return o === selected[i]; }); })[0];
    var label = $('[data-selected-value="' + radio.getAttribute('data-option') + '"]', root);
    if (label) label.textContent = radio.value;
    var btn = $('[data-add-button]', root);
    var btnLabel = btn && $('[data-add-label]', btn);
    if (!v) {
      if (btn) btn.disabled = true;
      if (btnLabel) btnLabel.textContent = 'Indisponible';
      return;
    }
    var idInput = $('[data-variant-input]', root);
    if (idInput) idInput.value = v.id;
    var price = $('[data-price]', root);
    if (price) price.innerHTML = priceHtml(v);
    if (btn) btn.disabled = !v.available;
    if (btnLabel) btnLabel.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
    var sectionId = root.getAttribute('data-section');
    var sticky = $('[data-sticky-atc="' + sectionId + '"] [data-sticky-price]');
    if (sticky) sticky.textContent = v.title + ' · ' + v.priceHtml;
    var gallery = document.getElementById('Gallery-' + sectionId);
    if (gallery && gallery.__goToMedia && v.media) gallery.__goToMedia(v.media);
    var url = root.getAttribute('data-update-url');
    if (url && window.history.replaceState) window.history.replaceState({}, '', url + '?variant=' + v.id);
  }
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('[data-product-root] input[type="radio"][data-option]');
    if (radio) { onVariantChange(radio); return; }
    var qty = e.target.closest('[data-line-qty]');
    if (qty) {
      var line = qty.closest('[data-line]');
      Cart.change(parseInt(line.getAttribute('data-line'), 10), Math.max(0, parseInt(qty.value, 10) || 0));
    }
  });

  /* Galerie produit */
  function initGallery(g) {
    if (g.__init) return;
    g.__init = true;
    var track = $('[data-gallery-track]', g);
    if (!track) return;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('[data-gallery-thumb]', g);
    var counter = $('[data-gallery-counter]', g);
    var index = 0;
    function mark(i) {
      index = i;
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      var th = thumbs[i];
      if (th) {
        var c = th.parentNode, cr = c.getBoundingClientRect(), tr = th.getBoundingClientRect();
        if (tr.left < cr.left || tr.right > cr.right) c.scrollBy({ left: tr.left - cr.left - (cr.width - tr.width) / 2, behavior: 'smooth' });
      }
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      mark(i);
    }
    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== index) mark(i);
      }, 60);
    }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = $('[data-gallery-prev]', g), next = $('[data-gallery-next]', g);
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    g.__goToMedia = function (id) {
      slides.forEach(function (s, k) { if (String(s.getAttribute('data-media-id')) === String(id)) go(k); });
    };
  }

  /* Dates de livraison estimées */
  function initDelivery(scope) {
    var fmt;
    try { fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); } catch (x) { return; }
    $$('[data-delivery]', scope).forEach(function (el) {
      var out = $('[data-delivery-dates]', el);
      if (!out) return;
      var min = parseInt(el.getAttribute('data-min'), 10) || 10;
      var max = parseInt(el.getAttribute('data-max'), 10) || 13;
      var d1 = new Date(), d2 = new Date();
      d1.setDate(d1.getDate() + min);
      d2.setDate(d2.getDate() + max);
      out.textContent = 'entre le ' + fmt.format(d1) + ' et le ' + fmt.format(d2);
    });
  }

  /* Barre d'achat fixe */
  function initSticky(bar) {
    if (bar.__init) return;
    bar.__init = true;
    var root = $('[data-product-root][data-section="' + bar.getAttribute('data-sticky-atc') + '"]');
    var mainBtn = root && $('[data-add-button]', root);
    var add = $('[data-sticky-add]', bar);
    if (!mainBtn || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (add) add.tabIndex = show ? 0 : -1;
    }).observe(mainBtn);
    if (add) add.addEventListener('click', function () {
      if (mainBtn.disabled) { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      var form = mainBtn.form;
      if (form && form.requestSubmit) form.requestSubmit(mainBtn); else mainBtn.click();
    });
  }

  /* Bandeau d'annonce (rotation sur mobile) */
  function initAnnouncement(el) {
    if (el.__init) return;
    el.__init = true;
    var items = $$('[data-announcement-item]', el);
    if (items.length < 2) return;
    var i = 0;
    var mq = window.matchMedia('(max-width: 989px)');
    setInterval(function () {
      if (!mq.matches || document.hidden) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  }

  /* Tri des collections et mot de passe oublié (pages conservées) */
  document.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-sort-select]');
    if (!sort) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    window.location.href = url.toString();
  });
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-recover-toggle]');
    if (!toggle) return;
    e.preventDefault();
    var box = $('.account-page__recover');
    if (box) box.classList.toggle('is-visible');
  });

  function init(scope) {
    scope = scope || document;
    initReveal(scope);
    $$('[data-gallery]', scope).forEach(initGallery);
    initDelivery(scope);
    $$('[data-sticky-atc]', scope).forEach(initSticky);
    $$('[data-announcement]', scope).forEach(initAnnouncement);
  }
  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();